import { RouterProvider } from "react-router-dom";
import ThemeProvider from "./theme";
import { ReactElement } from "react";
import appRoutes from "./routes";
import AppProgressBar from "./components/shared/appProgressBar/appProgressBar";
import "./App.scss";
import "./i18n";

function App(): ReactElement {
  return (
    <div className="App">
      <ThemeProvider>
        <AppProgressBar />
        <RouterProvider router={appRoutes} />
      </ThemeProvider>
    </div>
  );
}

export default App;
